var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCall2 = function SvgCall2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.157 3.14a7.305 7.305 0 0 1 6.453 6.446M13.157 6.388a4.057 4.057 0 0 1 3.208 3.208",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.112 12.282c3.657 3.655 4.486-.574 6.814 1.753 2.245 2.244 3.536 2.693.691 5.536-.356.287-2.62 3.73-10.573-4.22C-.911 7.396 2.531 5.13 2.818 4.775c2.85-2.851 3.293-1.554 5.538.69 2.327 2.328-1.9 3.16 1.756 6.816Z",
    stroke: "#203040",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCall2;